function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPngRemovebgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 180.5,5.5 C 181.833,6.16667 181.833,6.16667 180.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 432.5,5.5 C 433.833,6.16667 433.833,6.16667 432.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 97.5,7.5 C 98.8333,8.16667 98.8333,8.16667 97.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 93.5,16.5 C 94.8333,17.1667 94.8333,17.1667 93.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 160.5,24.5 C 161.833,25.1667 161.833,25.1667 160.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 428.5,24.5 C 429.833,25.1667 429.833,25.1667 428.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 198.5,26.5 C 199.833,27.1667 199.833,27.1667 198.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 18.5,29.5 C 19.8333,30.1667 19.8333,30.1667 18.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 236.5,29.5 C 237.833,30.1667 237.833,30.1667 236.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 248.5,31.5 C 249.833,32.1667 249.833,32.1667 248.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 372.5,33.5 C 373.833,34.1667 373.833,34.1667 372.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 105.5,44.5 C 106.833,45.1667 106.833,45.1667 105.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 259.5,44.5 C 260.833,45.1667 260.833,45.1667 259.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 321.5,45.5 C 322.833,46.1667 322.833,46.1667 321.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 37.5,59.5 C 38.8333,60.1667 38.8333,60.1667 37.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 137.5,63.5 C 138.833,64.1667 138.833,64.1667 137.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 380.5,74.5 C 381.833,75.1667 381.833,75.1667 380.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 282.5,96.5 C 283.833,97.1667 283.833,97.1667 282.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 328.5,100.5 C 329.833,101.167 329.833,101.167 328.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 28.5,102.5 C 29.8333,103.167 29.8333,103.167 28.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 241.5,114.5 C 242.833,115.167 242.833,115.167 241.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69050b",
    d: "M 205.5,127.5 C 203.143,127.337 200.81,127.503 198.5,128C 194.554,130.706 190.22,132.539 185.5,133.5C 189.946,130.774 194.613,128.274 199.5,126C 201.989,125.059 203.989,125.559 205.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.745
    },
    fill: "#5f0306",
    d: "M 313.5,127.5 C 318.5,129.664 323.167,132.331 327.5,135.5C 322.11,133.814 317.443,131.147 313.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#570409",
    d: "M 307.5,127.5 C 305.594,128.482 303.594,129.482 301.5,130.5C 302.193,131.518 302.859,132.518 303.5,133.5C 300.999,133.174 299.832,131.841 300,129.5C 302.301,128.133 304.801,127.466 307.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 270.5,133.5 C 271.833,134.167 271.833,134.167 270.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#72060c",
    d: "M 207.5,129.5 C 210.131,130.425 210.798,132.091 209.5,134.5C 206.394,136.952 203.061,138.952 199.5,140.5C 200.684,139.312 200.684,138.145 199.5,137C 202.26,136.326 204.927,135.493 207.5,134.5C 207.5,132.833 207.5,131.167 207.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 213.5,134.5 C 214.833,135.167 214.833,135.167 213.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#420301",
    d: "M 327.5,135.5 C 330.198,135.845 332.198,137.178 333.5,139.5C 331.147,138.66 329.147,137.326 327.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 409.5,137.5 C 410.833,138.167 410.833,138.167 409.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f080b",
    d: "M 185.5,133.5 C 183.475,135.075 181.475,136.908 179.5,139C 178.207,139.49 176.873,139.657 175.5,139.5C 178.494,137 181.827,135 185.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.859
    },
    fill: "#5a0606",
    d: "M 310.5,138.5 C 313.089,139.419 315.089,141.086 316.5,143.5C 313.911,142.581 311.911,140.914 310.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 463.5,138.5 C 464.833,139.167 464.833,139.167 463.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#67030b",
    d: "M 316.5,143.5 C 319.833,144.833 322.167,147.167 323.5,150.5C 320.833,148.5 318.5,146.167 316.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e060c",
    d: "M 333.5,139.5 C 338.047,141.706 342.047,144.706 345.5,148.5C 345.5,149.167 345.5,149.833 345.5,150.5C 343.319,148.829 340.985,147.329 338.5,146C 336.946,143.629 335.279,141.463 333.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 9.5,145.5 C 10.8333,146.167 10.8333,146.167 9.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#590403",
    d: "M 175.5,139.5 C 171.083,144.253 166.083,148.253 160.5,151.5C 164.917,146.747 169.917,142.747 175.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c0508",
    d: "M 199.5,140.5 C 186.754,150.578 175.754,162.245 166.5,175.5C 167.62,172.613 168.62,169.613 169.5,166.5C 170.086,166.709 170.586,167.043 171,167.5C 170.604,162.935 172.604,160.268 177,159.5C 178.009,157.975 178.509,156.308 178.5,154.5C 179.791,153.222 181.791,152.555 184.5,152.5C 184.5,151.167 184.5,149.833 184.5,148.5C 185.5,148.5 186.5,148.5 187.5,148.5C 187.34,146.801 187.506,145.134 188,143.5C 188.689,144.357 189.522,145.023 190.5,145.5C 191.167,143.833 191.833,142.167 192.5,140.5C 194.823,141.672 197.156,141.672 199.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.506
    },
    fill: "#4e0201",
    d: "M 345.5,148.5 C 349.898,151.895 353.564,155.895 356.5,160.5C 352.833,157.167 349.167,153.833 345.5,150.5C 345.5,149.833 345.5,149.167 345.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb0303",
    d: "M 205.5,127.5 C 206.5,127.833 207.167,128.5 207.5,129.5C 207.5,131.167 207.5,132.833 207.5,134.5C 204.927,135.493 202.26,136.326 199.5,137C 200.684,138.145 200.684,139.312 199.5,140.5C 197.156,141.672 194.823,141.672 192.5,140.5C 191.833,142.167 191.167,143.833 190.5,145.5C 189.522,145.023 188.689,144.357 188,143.5C 187.506,145.134 187.34,146.801 187.5,148.5C 186.5,148.5 185.5,148.5 184.5,148.5C 184.5,149.833 184.5,151.167 184.5,152.5C 181.791,152.555 179.791,153.222 178.5,154.5C 178.509,156.308 178.009,157.975 177,159.5C 172.604,160.268 170.604,162.935 171,167.5C 170.586,167.043 170.086,166.709 169.5,166.5C 168.62,169.613 167.62,172.613 166.5,175.5C 166.5,176.167 166.167,176.5 165.5,176.5C 160.51,180.14 157.843,185.14 157.5,191.5C 156.773,193.954 155.773,196.287 154.5,198.5C 152.215,201.335 150.882,204.668 150.5,208.5C 142.167,208.5 133.833,208.5 125.5,208.5C 126.968,202.763 128.635,197.097 130.5,191.5C 134.356,188.465 136.689,184.465 137.5,179.5C 140.209,177.097 142.209,174.097 143.5,170.5C 145.587,169.415 146.92,167.749 147.5,165.5C 151.38,162.973 154.046,159.64 155.5,155.5C 157.749,154.92 159.415,153.587 160.5,151.5C 166.083,148.253 171.083,144.253 175.5,139.5C 176.873,139.657 178.207,139.49 179.5,139C 181.475,136.908 183.475,135.075 185.5,133.5C 190.22,132.539 194.554,130.706 198.5,128C 200.81,127.503 203.143,127.337 205.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.424
    },
    fill: "#360a01",
    d: "M 160.5,151.5 C 159.415,153.587 157.749,154.92 155.5,155.5C 156.585,153.413 158.251,152.08 160.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#760509",
    d: "M 327.5,154.5 C 329.394,155.048 331.06,156.048 332.5,157.5C 336.02,162.274 339.02,167.274 341.5,172.5C 336.482,166.81 331.815,160.81 327.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.835
    },
    fill: "#650508",
    d: "M 155.5,155.5 C 154.046,159.64 151.38,162.973 147.5,165.5C 149.794,161.873 152.46,158.539 155.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#5b0304",
    d: "M 356.5,160.5 C 358.914,161.911 360.581,163.911 361.5,166.5C 359.086,165.089 357.419,163.089 356.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 209.5,163.5 C 210.833,164.167 210.833,164.167 209.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    fill: "#570303",
    d: "M 147.5,165.5 C 146.92,167.749 145.587,169.415 143.5,170.5C 144.08,168.251 145.413,166.585 147.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.506
    },
    fill: "#480504",
    d: "M 361.5,166.5 C 363.587,167.585 364.92,169.251 365.5,171.5C 364.167,170.5 362.833,169.5 361.5,168.5C 361.5,167.833 361.5,167.167 361.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#620505",
    d: "M 143.5,170.5 C 142.209,174.097 140.209,177.097 137.5,179.5C 138.723,175.951 140.723,172.951 143.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#580404",
    d: "M 341.5,173.5 C 343.074,173.937 344.241,174.937 345,176.5C 346.413,178.652 347.246,180.986 347.5,183.5C 345.012,180.534 343.012,177.201 341.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#470404",
    d: "M 263.5,177.5 C 257.653,175.184 251.653,174.85 245.5,176.5C 250.174,173.593 255.174,173.093 260.5,175C 261.942,175.377 262.942,176.21 263.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81070a",
    d: "M 361.5,168.5 C 362.833,169.5 364.167,170.5 365.5,171.5C 367.95,173.629 369.617,176.296 370.5,179.5C 369.504,179.586 368.671,179.252 368,178.5C 365.978,174.997 363.811,171.663 361.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#620607",
    d: "M 245.5,176.5 C 243.167,179.5 240.5,182.167 237.5,184.5C 239.167,180.833 241.833,178.167 245.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.569
    },
    fill: "#540303",
    d: "M 263.5,177.5 C 266.189,178.189 267.856,179.856 268.5,182.5C 266.451,181.118 264.785,179.452 263.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc0303",
    d: "M 263.5,177.5 C 264.785,179.452 266.451,181.118 268.5,182.5C 269.338,182.842 269.672,183.508 269.5,184.5C 270.397,189.14 270.564,193.806 270,198.5C 268.214,201.08 266.714,203.747 265.5,206.5C 264.5,206.5 263.5,206.5 262.5,206.5C 261.007,210.845 257.84,212.845 253,212.5C 248.64,211.904 244.806,210.071 241.5,207C 239.834,204.252 238.334,201.419 237,198.5C 236.436,193.806 236.603,189.14 237.5,184.5C 240.5,182.167 243.167,179.5 245.5,176.5C 251.653,174.85 257.653,175.184 263.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31
    },
    fill: "#3e0600",
    d: "M 370.5,179.5 C 371.906,179.973 372.573,180.973 372.5,182.5C 371.094,182.027 370.427,181.027 370.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 53.5,183.5 C 54.8333,184.167 54.8333,184.167 53.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75090c",
    d: "M 137.5,179.5 C 136.689,184.465 134.356,188.465 130.5,191.5C 131.828,186.835 134.161,182.835 137.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#710409",
    d: "M 165.5,176.5 C 163.084,181.667 160.418,186.667 157.5,191.5C 157.843,185.14 160.51,180.14 165.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.355
    },
    fill: "#565353",
    d: "M 347.5,183.5 C 348.401,184.29 349.068,185.29 349.5,186.5C 329.833,186.5 310.167,186.5 290.5,186.5C 290.5,196.5 290.5,206.5 290.5,216.5C 290.5,216.833 290.5,217.167 290.5,217.5C 289.506,207.013 289.172,196.346 289.5,185.5C 307.836,185.667 326.17,185.5 344.5,185C 345.737,184.768 346.737,184.268 347.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M 216.5,186.5 C 216.5,204.167 216.5,221.833 216.5,239.5C 183.996,239.168 151.662,239.502 119.5,240.5C 119.5,251.5 119.5,262.5 119.5,273.5C 118.945,277.012 119.612,280.012 121.5,282.5C 122.167,284.167 122.833,285.833 123.5,287.5C 124.224,290.843 125.057,294.176 126,297.5C 127.898,301.742 130.065,305.742 132.5,309.5C 132.5,310.167 132.5,310.833 132.5,311.5C 118.431,312.83 104.265,312.83 90,311.5C 89.5,277.502 89.3333,243.502 89.5,209.5C 122.004,209.832 154.338,209.498 186.5,208.5C 186.5,201.167 186.5,193.833 186.5,186.5C 196.5,186.5 206.5,186.5 216.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 349.5,186.5 C 351.843,191.876 354.177,197.209 356.5,202.5C 357.295,206.476 357.962,210.476 358.5,214.5C 336.191,216.49 313.525,217.156 290.5,216.5C 290.5,206.5 290.5,196.5 290.5,186.5C 310.167,186.5 329.833,186.5 349.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 374.5,186.5 C 388.833,186.5 403.167,186.5 417.5,186.5C 417.5,221.167 417.5,255.833 417.5,290.5C 405.5,290.5 393.5,290.5 381.5,290.5C 372.833,290.5 364.167,290.5 355.5,290.5C 343.833,290.5 332.167,290.5 320.5,290.5C 319.508,297.648 319.175,304.981 319.5,312.5C 309.5,312.5 299.5,312.5 289.5,312.5C 289.5,294.833 289.5,277.167 289.5,259.5C 313.5,259.5 337.5,259.5 361.5,259.5C 362.167,259.5 362.833,259.5 363.5,259.5C 371.5,259.5 379.5,259.5 387.5,259.5C 387.829,245.323 387.496,231.323 386.5,217.5C 384.359,211.074 382.025,204.74 379.5,198.5C 378.222,194.333 376.556,190.333 374.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#680507",
    d: "M 237.5,184.5 C 236.603,189.14 236.436,193.806 237,198.5C 238.334,201.419 239.834,204.252 241.5,207C 244.806,210.071 248.64,211.904 253,212.5C 257.84,212.845 261.007,210.845 262.5,206.5C 263.5,206.5 264.5,206.5 265.5,206.5C 266.714,203.747 268.214,201.08 270,198.5C 270.564,193.806 270.397,189.14 269.5,184.5C 273.391,191.081 273.224,197.748 269,204.5C 262.887,213.374 254.72,215.874 244.5,212C 234.244,204.75 231.911,195.583 237.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.424
    },
    fill: "#5e5e5e",
    d: "M 382.5,291.5 C 381.833,291.5 381.5,291.167 381.5,290.5C 393.5,290.5 405.5,290.5 417.5,290.5C 417.5,255.833 417.5,221.167 417.5,186.5C 403.167,186.5 388.833,186.5 374.5,186.5C 374.5,186.167 374.5,185.833 374.5,185.5C 388.673,185.804 403.006,185.471 417.5,184.5C 418.308,184.808 418.975,185.308 419.5,186C 418.608,221.18 418.275,256.346 418.5,291.5C 406.5,291.5 394.5,291.5 382.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be0303",
    d: "M 313.5,127.5 C 317.443,131.147 322.11,133.814 327.5,135.5C 329.147,137.326 331.147,138.66 333.5,139.5C 335.279,141.463 336.946,143.629 338.5,146C 340.985,147.329 343.319,148.829 345.5,150.5C 349.167,153.833 352.833,157.167 356.5,160.5C 357.419,163.089 359.086,165.089 361.5,166.5C 361.5,167.167 361.5,167.833 361.5,168.5C 363.811,171.663 365.978,174.997 368,178.5C 368.671,179.252 369.504,179.586 370.5,179.5C 370.427,181.027 371.094,182.027 372.5,182.5C 373.401,183.29 374.068,184.29 374.5,185.5C 374.5,185.833 374.5,186.167 374.5,186.5C 376.556,190.333 378.222,194.333 379.5,198.5C 380.688,205.225 382.188,211.892 384,218.5C 384.5,231.496 384.667,244.496 384.5,257.5C 377.833,257.5 371.167,257.5 364.5,257.5C 365.127,242.837 364.127,228.337 361.5,214C 361.603,212.439 361.937,210.939 362.5,209.5C 360.073,207.416 358.073,205.083 356.5,202.5C 354.177,197.209 351.843,191.876 349.5,186.5C 349.068,185.29 348.401,184.29 347.5,183.5C 347.246,180.986 346.413,178.652 345,176.5C 344.241,174.937 343.074,173.937 341.5,173.5C 341.5,173.167 341.5,172.833 341.5,172.5C 339.02,167.274 336.02,162.274 332.5,157.5C 331.06,156.048 329.394,155.048 327.5,154.5C 325.833,153.5 324.5,152.167 323.5,150.5C 322.167,147.167 319.833,144.833 316.5,143.5C 315.089,141.086 313.089,139.419 310.5,138.5C 307.883,137.214 305.55,135.547 303.5,133.5C 302.859,132.518 302.193,131.518 301.5,130.5C 303.594,129.482 305.594,128.482 307.5,127.5C 309.5,126.167 311.5,126.167 313.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.204
    },
    fill: "#363636",
    d: "M 219.5,240.5 C 218.833,240.5 218.167,240.5 217.5,240.5C 217.83,222.326 217.497,204.326 216.5,186.5C 206.5,186.5 196.5,186.5 186.5,186.5C 186.5,193.833 186.5,201.167 186.5,208.5C 186.167,208.5 185.833,208.5 185.5,208.5C 185.5,200.833 185.5,193.167 185.5,185.5C 196.5,185.5 207.5,185.5 218.5,185.5C 218.193,203.88 218.526,222.213 219.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 57.5,198.5 C 58.8333,199.167 58.8333,199.167 57.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 85.5,199.5 C 86.8333,200.167 86.8333,200.167 85.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#5c070a",
    d: "M 130.5,191.5 C 128.635,197.097 126.968,202.763 125.5,208.5C 124.833,208.5 124.167,208.5 123.5,208.5C 125.045,202.423 127.378,196.756 130.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38
    },
    fill: "#400601",
    d: "M 154.5,198.5 C 153.5,201.833 152.5,205.167 151.5,208.5C 151.167,208.5 150.833,208.5 150.5,208.5C 150.882,204.668 152.215,201.335 154.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.938
    },
    fill: "#cdc6c5",
    d: "M 123.5,208.5 C 124.167,208.5 124.833,208.5 125.5,208.5C 133.833,208.5 142.167,208.5 150.5,208.5C 150.833,208.5 151.167,208.5 151.5,208.5C 162.833,208.5 174.167,208.5 185.5,208.5C 185.833,208.5 186.167,208.5 186.5,208.5C 154.338,209.498 122.004,209.832 89.5,209.5C 89.3333,243.502 89.5,277.502 90,311.5C 104.265,312.83 118.431,312.83 132.5,311.5C 133.338,311.842 133.672,312.508 133.5,313.5C 118.5,313.5 103.5,313.5 88.5,313.5C 88.5,278.5 88.5,243.5 88.5,208.5C 100.167,208.5 111.833,208.5 123.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.674
    },
    fill: "#a9a7a7",
    d: "M 358.5,214.5 C 359.404,215.209 359.737,216.209 359.5,217.5C 358.833,217.5 358.167,217.5 357.5,217.5C 335.167,217.5 312.833,217.5 290.5,217.5C 290.5,217.167 290.5,216.833 290.5,216.5C 313.525,217.156 336.191,216.49 358.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#5c0809",
    d: "M 357.5,217.5 C 358.167,217.5 358.833,217.5 359.5,217.5C 360.222,217.918 360.722,218.584 361,219.5C 361.498,222.482 361.665,225.482 361.5,228.5C 360.9,224.587 359.567,220.921 357.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 320.5,221.5 C 321.833,222.167 321.833,222.167 320.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 46.5,222.5 C 47.8333,223.167 47.8333,223.167 46.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62
    },
    fill: "#480201",
    d: "M 254.5,223.5 C 249.833,223.5 245.167,223.5 240.5,223.5C 245.202,221.15 249.868,221.15 254.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#890809",
    d: "M 240.5,223.5 C 245.167,223.5 249.833,223.5 254.5,223.5C 257.614,223.555 259.948,224.888 261.5,227.5C 258.955,227.849 256.955,227.016 255.5,225C 248.805,224.335 242.138,224.502 235.5,225.5C 236.78,224.069 238.447,223.402 240.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad140f",
    d: "M 379.5,198.5 C 382.025,204.74 384.359,211.074 386.5,217.5C 386.5,231.167 386.5,244.833 386.5,258.5C 378.833,258.5 371.167,258.5 363.5,258.5C 363.666,249.494 363.5,240.494 363,231.5C 362.722,230.584 362.222,229.918 361.5,229.5C 361.5,229.167 361.5,228.833 361.5,228.5C 361.665,225.482 361.498,222.482 361,219.5C 360.722,218.584 360.222,217.918 359.5,217.5C 359.737,216.209 359.404,215.209 358.5,214.5C 357.962,210.476 357.295,206.476 356.5,202.5C 358.073,205.083 360.073,207.416 362.5,209.5C 361.937,210.939 361.603,212.439 361.5,214C 364.127,228.337 365.127,242.837 364.5,257.5C 371.167,257.5 377.833,257.5 384.5,257.5C 384.667,244.496 384.5,231.496 384,218.5C 382.188,211.892 380.688,205.225 379.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 81.5,227.5 C 82.8333,228.167 82.8333,228.167 81.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82070c",
    d: "M 263.5,229.5 C 266.164,231.484 267.831,234.151 268.5,237.5C 265.231,235.886 263.564,233.219 263.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.714
    },
    fill: "#530403",
    d: "M 235.5,225.5 C 230.842,230.124 226.175,234.791 221.5,239.5C 223.423,236.397 225.59,233.397 228,230.5C 230.4,228.585 232.9,226.919 235.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.793
    },
    fill: "#cec3c2",
    d: "M 216.5,186.5 C 217.497,204.326 217.83,222.326 217.5,240.5C 193.167,240.5 168.833,240.5 144.5,240.5C 136.167,240.5 127.833,240.5 119.5,240.5C 151.662,239.502 183.996,239.168 216.5,239.5C 216.5,221.833 216.5,204.167 216.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd0102",
    d: "M 261.5,227.5 C 262.5,227.833 263.167,228.5 263.5,229.5C 263.564,233.219 265.231,235.886 268.5,237.5C 269.275,242.797 269.608,248.13 269.5,253.5C 267.486,261.734 265.653,270.067 264,278.5C 263.667,278.167 263.333,277.833 263,277.5C 261.145,285.987 259.979,294.653 259.5,303.5C 258.184,306.087 257.517,309.087 257.5,312.5C 257.411,316.285 257.911,319.952 259,323.5C 263.484,326.73 266.984,326.063 269.5,321.5C 271.982,320.337 273.316,318.337 273.5,315.5C 273.5,314.833 273.833,314.5 274.5,314.5C 275.837,313.685 276.837,312.518 277.5,311C 278.899,310.405 280.232,310.572 281.5,311.5C 282.652,314.106 282.818,316.773 282,319.5C 280.337,321.158 279.504,323.158 279.5,325.5C 277.883,326.038 276.216,326.371 274.5,326.5C 274.5,328.167 274.5,329.833 274.5,331.5C 272.589,332.075 270.922,333.075 269.5,334.5C 266.267,334.36 263.601,335.527 261.5,338C 256.663,338.467 251.83,338.967 247,339.5C 242.321,338.662 237.821,337.328 233.5,335.5C 231.854,332.06 230.688,328.393 230,324.5C 229.333,323.833 228.667,323.167 228,322.5C 227.5,315.174 227.334,307.841 227.5,300.5C 228.345,299.329 229.011,297.995 229.5,296.5C 230.83,293.906 232.163,291.239 233.5,288.5C 234.799,289.09 235.632,290.09 236,291.5C 237.365,290.407 237.699,289.074 237,287.5C 236.08,287.07 235.247,286.736 234.5,286.5C 237.387,279.064 239.387,271.397 240.5,263.5C 243.181,258.932 244.014,253.932 243,248.5C 241.871,246.859 240.371,245.859 238.5,245.5C 238.167,245.5 237.833,245.5 237.5,245.5C 236.726,244.853 235.726,244.52 234.5,244.5C 232.172,245.789 229.839,247.122 227.5,248.5C 224.958,247.014 222.624,245.347 220.5,243.5C 219.596,242.791 219.263,241.791 219.5,240.5C 220.167,240.167 220.833,239.833 221.5,239.5C 226.175,234.791 230.842,230.124 235.5,225.5C 242.138,224.502 248.805,224.335 255.5,225C 256.955,227.016 258.955,227.849 261.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d36563",
    d: "M 386.5,217.5 C 387.496,231.323 387.829,245.323 387.5,259.5C 379.5,259.5 371.5,259.5 363.5,259.5C 363.5,259.167 363.5,258.833 363.5,258.5C 371.167,258.5 378.833,258.5 386.5,258.5C 386.5,244.833 386.5,231.167 386.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd0302",
    d: "M 144.5,269.5 C 144.658,273.841 145.658,277.841 147.5,281.5C 147.5,281.833 147.5,282.167 147.5,282.5C 147.5,283.5 147.5,284.5 147.5,285.5C 147.308,290.127 147.974,294.627 149.5,299C 148.833,300.333 148.167,301.667 147.5,303C 147.833,303.5 148.167,304 148.5,304.5C 149.386,303.675 149.719,302.675 149.5,301.5C 150.5,301.5 151.5,301.5 152.5,301.5C 152.396,304.09 153.063,306.423 154.5,308.5C 153.945,310.722 152.945,312.722 151.5,314.5C 151.833,315.167 152.167,315.833 152.5,316.5C 154.432,315.855 155.599,314.521 156,312.5C 158.338,318.238 161.838,322.905 166.5,326.5C 166.162,329.157 166.829,331.49 168.5,333.5C 171.185,335.524 173.852,337.524 176.5,339.5C 178.43,343.1 181.097,346.1 184.5,348.5C 184.833,348.5 185.167,348.5 185.5,348.5C 185.5,350.5 186.5,351.5 188.5,351.5C 189.082,354.584 190.915,356.584 194,357.5C 194.483,358.448 194.649,359.448 194.5,360.5C 196.921,360.878 199.254,361.545 201.5,362.5C 202.09,364.097 203.09,365.431 204.5,366.5C 203.643,367.425 202.643,368.092 201.5,368.5C 198.09,368.543 194.757,368.043 191.5,367C 189.968,366.3 188.968,365.134 188.5,363.5C 183.278,362.129 178.612,359.629 174.5,356C 173.207,355.51 171.873,355.343 170.5,355.5C 169.415,353.413 167.749,352.08 165.5,351.5C 162.769,347.766 159.436,344.766 155.5,342.5C 153.219,337.718 150.719,333.052 148,328.5C 145.741,327.62 143.575,326.62 141.5,325.5C 141.653,322.465 140.32,320.465 137.5,319.5C 136.702,317.034 135.369,315.034 133.5,313.5C 133.672,312.508 133.338,311.842 132.5,311.5C 132.5,310.833 132.5,310.167 132.5,309.5C 132.569,304.815 131.069,300.815 128,297.5C 126.768,293.939 125.268,290.606 123.5,287.5C 122.833,285.833 122.167,284.167 121.5,282.5C 121.296,279.482 120.963,276.482 120.5,273.5C 120.5,262.833 120.5,252.167 120.5,241.5C 127.833,241.5 135.167,241.5 142.5,241.5C 142.334,248.841 142.5,256.174 143,263.5C 143.191,265.708 143.691,267.708 144.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.449
    },
    fill: "#58090c",
    d: "M 361.5,229.5 C 362.222,229.918 362.722,230.584 363,231.5C 363.5,240.494 363.666,249.494 363.5,258.5C 363.5,258.833 363.5,259.167 363.5,259.5C 362.833,259.5 362.167,259.5 361.5,259.5C 361.5,259.167 361.5,258.833 361.5,258.5C 362.65,248.853 362.65,239.186 361.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#540608",
    d: "M 220.5,243.5 C 222.624,245.347 224.958,247.014 227.5,248.5C 229.839,247.122 232.172,245.789 234.5,244.5C 235.726,244.52 236.726,244.853 237.5,245.5C 236.127,245.343 234.793,245.51 233.5,246C 227.903,252.42 223.57,251.587 220.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 181.5,244.5 C 182.833,245.167 182.833,245.167 181.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.767
    },
    fill: "#590708",
    d: "M 268.5,237.5 C 269.268,238.263 269.768,239.263 270,240.5C 270.821,247.346 270.654,254.013 269.5,260.5C 269.5,258.167 269.5,255.833 269.5,253.5C 269.608,248.13 269.275,242.797 268.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 235.5,251.5 C 236.833,252.167 236.833,252.167 235.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#901415",
    d: "M 119.5,240.5 C 127.833,240.5 136.167,240.5 144.5,240.5C 144.5,248.5 144.5,256.5 144.5,264.5C 144.5,266.167 144.5,267.833 144.5,269.5C 143.691,267.708 143.191,265.708 143,263.5C 142.5,256.174 142.334,248.841 142.5,241.5C 135.167,241.5 127.833,241.5 120.5,241.5C 120.5,252.167 120.5,262.833 120.5,273.5C 120.167,273.5 119.833,273.5 119.5,273.5C 119.5,262.5 119.5,251.5 119.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.273
    },
    fill: "#424242",
    d: "M 361.5,258.5 C 361.5,258.833 361.5,259.167 361.5,259.5C 337.5,259.5 313.5,259.5 289.5,259.5C 289.5,277.167 289.5,294.833 289.5,312.5C 299.653,313.494 309.986,313.828 320.5,313.5C 309.765,314.829 298.931,314.829 288,313.5C 288.313,295.102 288.479,276.769 288.5,258.5C 312.833,258.5 337.167,258.5 361.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#610104",
    d: "M 238.5,245.5 C 240.371,245.859 241.871,246.859 243,248.5C 244.014,253.932 243.181,258.932 240.5,263.5C 241.422,258.528 241.588,253.528 241,248.5C 239.955,247.627 239.122,246.627 238.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.076
    },
    fill: "#420102",
    d: "M 269.5,263.5 C 269.142,266.689 268.475,269.689 267.5,272.5C 267.068,269.123 267.735,266.123 269.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#5d0304",
    d: "M 144.5,264.5 C 145.804,269.984 146.804,275.651 147.5,281.5C 145.658,277.841 144.658,273.841 144.5,269.5C 144.5,267.833 144.5,266.167 144.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 194.5,273.5 C 195.833,274.167 195.833,274.167 194.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#4a1613",
    d: "M 119.5,273.5 C 119.833,273.5 120.167,273.5 120.5,273.5C 120.963,276.482 121.296,279.482 121.5,282.5C 119.612,280.012 118.945,277.012 119.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 427.5,278.5 C 428.833,279.167 428.833,279.167 427.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M 147.5,282.5 C 170.167,282.5 192.833,282.5 215.5,282.5C 215.5,292.5 215.5,302.5 215.5,312.5C 196.5,312.5 177.5,312.5 158.5,312.5C 154.51,303.536 150.844,294.536 147.5,285.5C 147.5,284.5 147.5,283.5 147.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#970509",
    d: "M 240.5,263.5 C 239.387,271.397 237.387,279.064 234.5,286.5C 235.247,286.736 236.08,287.07 237,287.5C 237.699,289.074 237.365,290.407 236,291.5C 235.632,290.09 234.799,289.09 233.5,288.5C 232.163,291.239 230.83,293.906 229.5,296.5C 229.5,295.5 229.5,294.5 229.5,293.5C 232.393,283.147 236.06,273.147 240.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#870708",
    d: "M 269.5,253.5 C 269.5,255.833 269.5,258.167 269.5,260.5C 269.5,261.5 269.5,262.5 269.5,263.5C 267.735,266.123 267.068,269.123 267.5,272.5C 265.278,283.058 262.611,293.391 259.5,303.5C 259.979,294.653 261.145,285.987 263,277.5C 263.333,277.833 263.667,278.167 264,278.5C 265.653,270.067 267.486,261.734 269.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.195
    },
    fill: "#2e2d2c",
    d: "M 320.5,291.5 C 320.5,291.167 320.5,290.833 320.5,290.5C 332.167,290.5 343.833,290.5 355.5,290.5C 355.5,290.833 355.5,291.167 355.5,291.5C 354.833,292.167 354.167,292.833 353.5,293.5C 342.884,291.523 331.884,290.856 320.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a93737",
    d: "M 355.5,291.5 C 355.5,291.167 355.5,290.833 355.5,290.5C 364.167,290.5 372.833,290.5 381.5,290.5C 381.5,291.167 381.833,291.5 382.5,291.5C 382.34,293.153 381.674,294.486 380.5,295.5C 380.5,294.167 380.5,292.833 380.5,291.5C 372.167,291.5 363.833,291.5 355.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 56.5,296.5 C 57.8333,297.167 57.8333,297.167 56.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78
    },
    fill: "#5a0102",
    d: "M 229.5,293.5 C 229.5,294.5 229.5,295.5 229.5,296.5C 229.011,297.995 228.345,299.329 227.5,300.5C 227.41,297.848 228.076,295.515 229.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.925
    },
    fill: "#620608",
    d: "M 355.5,291.5 C 354.513,296.296 353.013,300.963 351,305.5C 350.502,307.544 349.335,308.878 347.5,309.5C 350.063,304.375 352.063,299.042 353.5,293.5C 354.167,292.833 354.833,292.167 355.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac1d1a",
    d: "M 123.5,287.5 C 125.268,290.606 126.768,293.939 128,297.5C 131.069,300.815 132.569,304.815 132.5,309.5C 130.065,305.742 127.898,301.742 126,297.5C 125.057,294.176 124.224,290.843 123.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd0303",
    d: "M 355.5,291.5 C 363.833,291.5 372.167,291.5 380.5,291.5C 380.5,292.833 380.5,294.167 380.5,295.5C 380.737,296.791 380.404,297.791 379.5,298.5C 375.614,302.271 373.281,306.937 372.5,312.5C 369.029,313.633 367.029,315.967 366.5,319.5C 365.5,319.5 364.5,319.5 363.5,319.5C 363.799,321.604 363.466,323.604 362.5,325.5C 361.914,325.291 361.414,324.957 361,324.5C 360.667,326.167 360.333,327.833 360,329.5C 359.586,329.043 359.086,328.709 358.5,328.5C 357.833,329.5 357.167,330.5 356.5,331.5C 355.325,330.145 354.325,330.312 353.5,332C 356.038,334.359 355.371,335.859 351.5,336.5C 352.127,337.417 352.461,338.417 352.5,339.5C 350.21,343.158 347.21,346.158 343.5,348.5C 341.596,348.738 340.262,349.738 339.5,351.5C 337.596,351.738 336.262,352.738 335.5,354.5C 334.022,354.238 332.689,354.571 331.5,355.5C 329.389,356.605 328.055,358.271 327.5,360.5C 324.715,359.916 323.048,360.916 322.5,363.5C 319.68,363.087 317.68,364.087 316.5,366.5C 312.589,367.526 308.756,368.86 305,370.5C 303.594,369.586 302.094,368.92 300.5,368.5C 300.077,367.735 299.743,366.902 299.5,366C 301.23,364.005 302.563,361.838 303.5,359.5C 303.973,358.094 304.973,357.427 306.5,357.5C 315.071,352.93 322.071,346.597 327.5,338.5C 329.587,337.415 330.92,335.749 331.5,333.5C 333.587,332.415 334.92,330.749 335.5,328.5C 338.471,326.557 340.471,323.891 341.5,320.5C 345.298,317.909 347.298,314.243 347.5,309.5C 349.335,308.878 350.502,307.544 351,305.5C 353.013,300.963 354.513,296.296 355.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 324.5,302.5 C 325.833,303.167 325.833,303.167 324.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#710609",
    d: "M 379.5,298.5 C 377.913,303.632 375.579,308.298 372.5,312.5C 373.281,306.937 375.614,302.271 379.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.712
    },
    fill: "#76070b",
    d: "M 259.5,303.5 C 257.808,310.012 258.308,316.345 261,322.5C 261.689,323.357 262.522,324.023 263.5,324.5C 265.534,323.441 267.534,322.441 269.5,321.5C 266.984,326.063 263.484,326.73 259,323.5C 257.911,319.952 257.411,316.285 257.5,312.5C 257.517,309.087 258.184,306.087 259.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad140f",
    d: "M 147.5,285.5 C 150.844,294.536 154.51,303.536 158.5,312.5C 158.842,313.338 159.508,313.672 160.5,313.5C 160.263,314.791 160.596,315.791 161.5,316.5C 162.11,317.391 162.443,318.391 162.5,319.5C 162.427,321.027 163.094,322.027 164.5,322.5C 165.674,323.514 166.34,324.847 166.5,326.5C 161.838,322.905 158.338,318.238 156,312.5C 155.599,314.521 154.432,315.855 152.5,316.5C 152.167,315.833 151.833,315.167 151.5,314.5C 152.945,312.722 153.945,310.722 154.5,308.5C 153.063,306.423 152.396,304.09 152.5,301.5C 151.5,301.5 150.5,301.5 149.5,301.5C 149.719,302.675 149.386,303.675 148.5,304.5C 148.167,304 147.833,303.5 147.5,303C 148.167,301.667 148.833,300.333 149.5,299C 147.974,294.627 147.308,290.127 147.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.867
    },
    fill: "#939392",
    d: "M 147.5,282.5 C 147.5,282.167 147.5,281.833 147.5,281.5C 170.5,281.5 193.5,281.5 216.5,281.5C 216.5,292.167 216.5,302.833 216.5,313.5C 197.833,313.5 179.167,313.5 160.5,313.5C 159.508,313.672 158.842,313.338 158.5,312.5C 177.5,312.5 196.5,312.5 215.5,312.5C 215.5,302.5 215.5,292.5 215.5,282.5C 192.833,282.5 170.167,282.5 147.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.833
    },
    fill: "#b2b2b2",
    d: "M 320.5,290.5 C 320.5,290.833 320.5,291.167 320.5,291.5C 320.5,298.833 320.5,306.167 320.5,313.5C 309.986,313.828 299.653,313.494 289.5,312.5C 299.5,312.5 309.5,312.5 319.5,312.5C 319.175,304.981 319.508,297.648 320.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.136
    },
    fill: "#232322",
    d: "M 160.5,313.5 C 179.167,313.5 197.833,313.5 216.5,313.5C 197.977,313.837 179.644,314.837 161.5,316.5C 160.596,315.791 160.263,314.791 160.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.741
    },
    fill: "#421a15",
    d: "M 88.5,313.5 C 103.5,313.5 118.5,313.5 133.5,313.5C 135.369,315.034 136.702,317.034 137.5,319.5C 135.661,318.492 134.328,316.992 133.5,315C 118.328,314.831 103.328,314.331 88.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#700608",
    d: "M 279.5,325.5 C 279.504,323.158 280.337,321.158 282,319.5C 282.818,316.773 282.652,314.106 281.5,311.5C 280.232,310.572 278.899,310.405 277.5,311C 276.837,312.518 275.837,313.685 274.5,314.5C 274.726,311.445 276.059,309.111 278.5,307.5C 281.575,309.066 284.242,311.233 286.5,314C 284.518,318.147 282.184,321.98 279.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 117.5,315.5 C 118.833,316.167 118.833,316.167 117.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#78040a",
    d: "M 347.5,309.5 C 347.298,314.243 345.298,317.909 341.5,320.5C 343.25,316.665 345.25,312.999 347.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77080c",
    d: "M 227.5,300.5 C 227.334,307.841 227.5,315.174 228,322.5C 228.667,323.167 229.333,323.833 230,324.5C 230.688,328.393 231.854,332.06 233.5,335.5C 229.444,331.389 226.944,326.389 226,320.5C 225.333,315.167 225.333,309.833 226,304.5C 226.21,302.942 226.71,301.609 227.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 493.5,317.5 C 494.833,318.167 494.833,318.167 493.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.573
    },
    fill: "#570404",
    d: "M 273.5,315.5 C 273.316,318.337 271.982,320.337 269.5,321.5C 270.475,319.205 271.808,317.205 273.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71040b",
    d: "M 137.5,319.5 C 140.32,320.465 141.653,322.465 141.5,325.5C 139.178,324.198 137.845,322.198 137.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.255
    },
    fill: "#3c0501",
    d: "M 162.5,319.5 C 163.906,319.973 164.573,320.973 164.5,322.5C 163.094,322.027 162.427,321.027 162.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.839
    },
    fill: "#640205",
    d: "M 341.5,320.5 C 340.471,323.891 338.471,326.557 335.5,328.5C 337.016,325.467 339.016,322.8 341.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c0609",
    d: "M 279.5,325.5 C 278.581,328.089 276.914,330.089 274.5,331.5C 274.5,329.833 274.5,328.167 274.5,326.5C 276.216,326.371 277.883,326.038 279.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#84040a",
    d: "M 166.5,326.5 C 170.073,330.644 173.406,334.978 176.5,339.5C 173.852,337.524 171.185,335.524 168.5,333.5C 166.829,331.49 166.162,329.157 166.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91060b",
    d: "M 141.5,325.5 C 143.575,326.62 145.741,327.62 148,328.5C 150.719,333.052 153.219,337.718 155.5,342.5C 151.169,339.002 147.336,335.002 144,330.5C 142.906,328.922 142.072,327.255 141.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.604
    },
    fill: "#580305",
    d: "M 335.5,328.5 C 334.92,330.749 333.587,332.415 331.5,333.5C 332.08,331.251 333.413,329.585 335.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#950509",
    d: "M 372.5,312.5 C 368.026,323.112 361.359,332.112 352.5,339.5C 352.461,338.417 352.127,337.417 351.5,336.5C 355.371,335.859 356.038,334.359 353.5,332C 354.325,330.312 355.325,330.145 356.5,331.5C 357.167,330.5 357.833,329.5 358.5,328.5C 359.086,328.709 359.586,329.043 360,329.5C 360.333,327.833 360.667,326.167 361,324.5C 361.414,324.957 361.914,325.291 362.5,325.5C 363.466,323.604 363.799,321.604 363.5,319.5C 364.5,319.5 365.5,319.5 366.5,319.5C 367.029,315.967 369.029,313.633 372.5,312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 36.5,333.5 C 37.8333,334.167 37.8333,334.167 36.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#4d0101",
    d: "M 274.5,331.5 C 273.415,333.587 271.749,334.92 269.5,335.5C 269.5,335.167 269.5,334.833 269.5,334.5C 270.922,333.075 272.589,332.075 274.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.255
    },
    fill: "#4e0303",
    d: "M 269.5,335.5 C 267.97,337.346 265.97,338.346 263.5,338.5C 265.03,336.654 267.03,335.654 269.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.612
    },
    fill: "#510502",
    d: "M 331.5,333.5 C 330.92,335.749 329.587,337.415 327.5,338.5C 328.08,336.251 329.413,334.585 331.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#88080a",
    d: "M 269.5,334.5 C 269.5,334.833 269.5,335.167 269.5,335.5C 267.03,335.654 265.03,336.654 263.5,338.5C 262.791,339.404 261.791,339.737 260.5,339.5C 255.195,340.194 249.862,340.528 244.5,340.5C 240.164,340.163 236.497,338.496 233.5,335.5C 237.821,337.328 242.321,338.662 247,339.5C 251.83,338.967 256.663,338.467 261.5,338C 263.601,335.527 266.267,334.36 269.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.855
    },
    fill: "#4f0402",
    d: "M 176.5,339.5 C 179.903,341.9 182.57,344.9 184.5,348.5C 181.097,346.1 178.43,343.1 176.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.147
    },
    fill: "#3d0100",
    d: "M 260.5,339.5 C 257.45,340.935 254.117,341.602 250.5,341.5C 248.304,341.495 246.304,341.162 244.5,340.5C 249.862,340.528 255.195,340.194 260.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 19.5,341.5 C 20.8333,342.167 20.8333,342.167 19.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#620205",
    d: "M 155.5,342.5 C 159.436,344.766 162.769,347.766 165.5,351.5C 161.564,349.234 158.231,346.234 155.5,342.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    fill: "#430302",
    d: "M 185.5,348.5 C 186.833,349.167 187.833,350.167 188.5,351.5C 186.5,351.5 185.5,350.5 185.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.086
    },
    fill: "#430202",
    d: "M 343.5,348.5 C 342.738,350.262 341.404,351.262 339.5,351.5C 340.262,349.738 341.596,348.738 343.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 196.5,350.5 C 197.833,351.167 197.833,351.167 196.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 467.5,351.5 C 468.833,352.167 468.833,352.167 467.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.773
    },
    fill: "#610405",
    d: "M 327.5,338.5 C 322.071,346.597 315.071,352.93 306.5,357.5C 313.773,351.565 320.773,345.232 327.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22
    },
    fill: "#550003",
    d: "M 339.5,351.5 C 338.738,353.262 337.404,354.262 335.5,354.5C 336.262,352.738 337.596,351.738 339.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.671
    },
    fill: "#5e0306",
    d: "M 165.5,351.5 C 167.749,352.08 169.415,353.413 170.5,355.5C 168.251,354.92 166.585,353.587 165.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 111.5,354.5 C 112.833,355.167 112.833,355.167 111.5,354.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71040b",
    d: "M 335.5,354.5 C 333.23,356.975 330.563,358.975 327.5,360.5C 328.055,358.271 329.389,356.605 331.5,355.5C 332.689,354.571 334.022,354.238 335.5,354.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 494.5,357.5 C 495.833,358.167 495.833,358.167 494.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a040a",
    d: "M 188.5,351.5 C 193.152,354.821 197.485,358.487 201.5,362.5C 199.254,361.545 196.921,360.878 194.5,360.5C 194.649,359.448 194.483,358.448 194,357.5C 190.915,356.584 189.082,354.584 188.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 113.5,360.5 C 114.833,361.167 114.833,361.167 113.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.584
    },
    fill: "#570709",
    d: "M 327.5,360.5 C 326.101,361.89 324.434,362.89 322.5,363.5C 323.048,360.916 324.715,359.916 327.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#920609",
    d: "M 170.5,355.5 C 171.873,355.343 173.207,355.51 174.5,356C 178.612,359.629 183.278,362.129 188.5,363.5C 188.968,365.134 189.968,366.3 191.5,367C 194.757,368.043 198.09,368.543 201.5,368.5C 201.5,368.833 201.5,369.167 201.5,369.5C 201.167,369.5 200.833,369.5 200.5,369.5C 198.167,369.5 195.833,369.5 193.5,369.5C 184.774,366.413 177.107,361.747 170.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#5f0507",
    d: "M 322.5,363.5 C 320.819,365.008 318.819,366.008 316.5,366.5C 317.68,364.087 319.68,363.087 322.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#5e0407",
    d: "M 201.5,362.5 C 209.355,365.16 209.355,367.493 201.5,369.5C 201.5,369.167 201.5,368.833 201.5,368.5C 202.643,368.092 203.643,367.425 204.5,366.5C 203.09,365.431 202.09,364.097 201.5,362.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d070f",
    d: "M 303.5,359.5 C 302.563,361.838 301.23,364.005 299.5,366C 299.743,366.902 300.077,367.735 300.5,368.5C 298.456,367.969 296.789,366.802 295.5,365C 297.704,362.406 300.37,360.572 303.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "#650306",
    d: "M 316.5,366.5 C 313.154,369.085 309.321,370.752 305,371.5C 302.817,371.478 301.317,370.478 300.5,368.5C 302.094,368.92 303.594,369.586 305,370.5C 308.756,368.86 312.589,367.526 316.5,366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.714
    },
    fill: "#450808",
    d: "M 193.5,369.5 C 195.833,369.5 198.167,369.5 200.5,369.5C 197.96,371.426 195.627,371.426 193.5,369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 413.5,393.5 C 414.833,394.167 414.833,394.167 413.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 246.5,408.5 C 247.833,409.167 247.833,409.167 246.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 280.5,409.5 C 281.833,410.167 281.833,410.167 280.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 371.5,410.5 C 372.833,411.167 372.833,411.167 371.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 80.5,412.5 C 81.8333,413.167 81.8333,413.167 80.5,412.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 217.5,414.5 C 218.833,415.167 218.833,415.167 217.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 364.5,425.5 C 365.833,426.167 365.833,426.167 364.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 419.5,451.5 C 420.833,452.167 420.833,452.167 419.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 186.5,454.5 C 187.833,455.167 187.833,455.167 186.5,454.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 358.5,456.5 C 359.833,457.167 359.833,457.167 358.5,456.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 265.5,470.5 C 266.833,471.167 266.833,471.167 265.5,470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 187.5,475.5 C 188.833,476.167 188.833,476.167 187.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 162.5,483.5 C 163.833,484.167 163.833,484.167 162.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 303.5,484.5 C 304.833,485.167 304.833,485.167 303.5,484.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#000000",
    d: "M 386.5,485.5 C 387.833,486.167 387.833,486.167 386.5,485.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPngRemovebgPreview);
export default __webpack_public_path__ + "static/media/logo_png-removebg-preview.73a55986ff0add81157c65dfcefdecb2.svg";
export { ForwardRef as ReactComponent };